// extracted by mini-css-extract-plugin
module.exports = {"switch":"DisplayStyleControl-module__switch___JHH_P"};